import type { EditTarget } from '../../Hooks/Price-simulation/useWorksheetAdjustments.types';
import { formatTwoDecimals, toDecimalInputValue, toNumberInputValue } from '../../Utils/decimalUtils';
import AdjustmentInput from './AdjustmentInput';
import type { InputMode, WorksheetInputEditor } from './PriceSimulationWorksheet.types';

interface WorksheetAdjustmentCellProps {
    target: EditTarget;
    currentPrice: number;
    newPrice: number;
    adjustment: number;
    isKrOnly: boolean;
    isLocked: boolean;
    editor: WorksheetInputEditor;
}

const WorksheetAdjustmentCell = ({ target, currentPrice, newPrice, adjustment, isKrOnly, isLocked, editor }: WorksheetAdjustmentCellProps) => {
    const mode: InputMode = isKrOnly ? 'fixed' : editor.getInputMode(target);
    const isFixed = mode === 'fixed';
    const value = editor.getEditingValue(target) ?? (isFixed ? toDecimalInputValue(newPrice) : toNumberInputValue(adjustment));

    return (
        <AdjustmentInput
            isFixed={isFixed}
            isKrOnly={isKrOnly}
            value={value}
            placeholder={isFixed ? formatTwoDecimals(currentPrice) : formatTwoDecimals(0)}
            disabled={isLocked}
            onChange={(next) => editor.onChange(target, next)}
            onBlur={() => editor.onBlur(target, mode, currentPrice)}
            onToggleMode={() => editor.onToggleMode(target)}
        />
    );
};

export default WorksheetAdjustmentCell;
